var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.05 33.1 35.2 18.95l-2.3-2.25-11.85 11.85-6-6-2.25 2.25 8.25 8.3ZM24 44c-2.733 0-5.317-.525-7.75-1.575-2.433-1.05-4.558-2.483-6.375-4.3-1.817-1.817-3.25-3.942-4.3-6.375C4.525 29.317 4 26.733 4 24c0-2.767.525-5.367 1.575-7.8 1.05-2.433 2.483-4.55 4.3-6.35 1.817-1.8 3.942-3.225 6.375-4.275C18.683 4.525 21.267 4 24 4c2.767 0 5.367.525 7.8 1.575 2.433 1.05 4.55 2.475 6.35 4.275 1.8 1.8 3.225 3.917 4.275 6.35C43.475 18.633 44 21.233 44 24c0 2.733-.525 5.317-1.575 7.75-1.05 2.433-2.475 4.558-4.275 6.375-1.8 1.817-3.917 3.25-6.35 4.3C29.367 43.475 26.767 44 24 44Zm0-3c4.733 0 8.75-1.658 12.05-4.975C39.35 32.708 41 28.7 41 24c0-4.733-1.65-8.75-4.95-12.05C32.75 8.65 28.733 7 24 7c-4.7 0-8.708 1.65-12.025 4.95C8.658 15.25 7 19.267 7 24c0 4.7 1.658 8.708 4.975 12.025C15.292 39.342 19.3 41 24 41Z",
    style: {
      fill: "#00870c",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success-circle.0f286b52010a8d9c3241c83aeb47069f.svg";
export { ForwardRef as ReactComponent };